import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DEFAULT_TITLE = "소름 SORM";
const DEFAULT_DESCRIPTION = "수비학 기반의 운세 서비스 SORM, 소름만의 운명의 숫자로 소름 돋는 운세 풀이를 알려드립니다.";
const DEFAULT_IMAGE = "https://sorm.co.kr/logo.svg";

const upsertMetaTag = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("meta");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const upsertLinkTag = (selector, attributes) => {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement("link");
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
};

const usePageMeta = ({
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  robots = "index,follow",
  image = DEFAULT_IMAGE,
  canonicalPath,
} = {}) => {
  const location = useLocation();

  useEffect(() => {
    const { origin } = window.location;
    const path = canonicalPath ?? location.pathname;
    const canonicalUrl = new URL(path, origin).toString();
    const fullTitle = title === DEFAULT_TITLE ? title : `${title} | ${DEFAULT_TITLE}`;

    document.title = fullTitle;
    document.documentElement.lang = "ko";

    upsertMetaTag('meta[name="description"]', { name: "description", content: description });
    upsertMetaTag('meta[name="robots"]', { name: "robots", content: robots });
    upsertMetaTag('meta[property="og:type"]', { property: "og:type", content: "website" });
    upsertMetaTag('meta[property="og:site_name"]', { property: "og:site_name", content: DEFAULT_TITLE });
    upsertMetaTag('meta[property="og:locale"]', { property: "og:locale", content: "ko_KR" });
    upsertMetaTag('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    upsertMetaTag('meta[property="og:description"]', { property: "og:description", content: description });
    upsertMetaTag('meta[property="og:url"]', { property: "og:url", content: canonicalUrl });
    upsertMetaTag('meta[property="og:image"]', { property: "og:image", content: image });
    upsertMetaTag('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsertMetaTag('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    upsertMetaTag('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    upsertMetaTag('meta[name="twitter:image"]', { name: "twitter:image", content: image });
    upsertLinkTag('link[rel="canonical"]', { rel: "canonical", href: canonicalUrl });
  }, [canonicalPath, description, image, location.pathname, robots, title]);
};

export default usePageMeta;
